export const safeAsync = async (
    fn: () => Promise<void>,
    errorHandler?: (error: Error | null) => void
) => {
    try {
        await fn();
    } catch (err) {
        errorHandler?.(err instanceof Error ? err : new Error(String(err)));
    }
};

export const safeAsyncWithResult = async <T, E = Error>(
    fn: () => Promise<T>
): Promise<{ data?: T; error?: E }> => {
    try {
        return { data: await fn() };
    } catch (error) {
        return { error: error as E };
    }
};

export function isValidFirestoreCollectionPath(path: string): boolean {
    if (!path || typeof path !== 'string' || path.trim() === '') {
        return false;
    }

    const segments = path.split('/').filter(s => s.trim() !== '');

    if (segments.length === 0 || segments.length % 2 === 0) {
        return false;
    }

    for (const segment of segments) {
        if (segment.includes('/') || segment === '.' || segment === '..') {
            return false;
        }
        if (segment === 'null' || segment === 'undefined') {
            return false;
        }
        if (segment.length === 0) {
            return false;
        }
    }

    return true;
}
